import React from 'react';

import { PopupTheme } from './enums';
import { useTransferUserPopup } from './hooks/useTransferUserPopup';
import { TransferUserPopupCarousel } from './submodules/TransferUserPopupCarousel';
import { TransferUserPopupDefault } from './submodules/TransferUserPopupDefault';

export const TransferUserPopup = React.memo(() => {
  const { isVisible, theme, handleMount, handleSubmit, handleClose } =
    useTransferUserPopup();

  if (!isVisible) {
    return null;
  }

  if (theme === PopupTheme.Default) {
    return (
      <TransferUserPopupDefault
        onMount={handleMount}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />
    );
  }

  if (theme === PopupTheme.Carousel) {
    return (
      <TransferUserPopupCarousel
        onMount={handleMount}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />
    );
  }

  return null;
});
